import React, { useEffect, useState } from "react";
import "../styles/NotFound.scss";
import { isMobile } from "react-device-detect";
import { Button } from "react-bootstrap";
import { PAGE } from "../constants/page";
import { useLocation, useNavigate } from "react-router-dom";
import Footer from "../components/Footer";
import IdleUserHeader from "src/components/IdleUserHeader";
import { useAuth } from "react-oidc-context";
import ClickToCall from "src/components/ClickToCall";
import { Trans } from "react-i18next";

const NotFound = () => {
  const navigate = useNavigate();
  const userLocation = useLocation();
  const auth = useAuth();

  const handleGotoHome = () => {
    if (userLocation && !userLocation.state) {
      navigate(PAGE.LOGIN);
    } else {
      navigate(PAGE.GLOBAL_HOME);
    }
  };
  return (
    <div className="not-found-background-container">
      {!auth.isAuthenticated ? <IdleUserHeader /> : null}
      <div
        className={
          isMobile
            ? "d-flex flex-column not-found-container-mobile"
            : "d-flex flex-row justify-content-center not-found-container-desktop align-items-baseline"
        }
      >
        <div className="image-container">
          <img src="/icons/404_icon.svg" />
        </div>
        <div className="text-container">
          <div className="text-not-found-title">
            {userLocation.state
              ? <Trans i18nKey={userLocation.state.errMsgHeader}></Trans>
              : <Trans i18nKey={"heading_page_not_found"}></Trans>}
          </div>
          <div className="text-not-found-content">
            {userLocation.state
              ? <Trans i18nKey={userLocation.state.errMsg1}></Trans>
              : <Trans i18nKey={"description_page_not_found1"}></Trans>}
          </div>
          <div className="text-not-found-content">
            {userLocation.state ? (
              // ? userLocation.state.errMsg2
              <ClickToCall page="404" messageKey={userLocation.state.errMsg2} />
            ) : (
              <Trans i18nKey={"description_page_not_found2"}></Trans>
            )}
          </div>
          <div className="text-not-found-content">
            {userLocation.state ? (
              // ? userLocation.state.errMsg3
              <ClickToCall page="404" messageKey={userLocation.state.errMsg3} />
            ) : (
              <Trans i18nKey={"description_page_not_found3"}></Trans>
            )}
          </div>
          {userLocation?.state?.keycloakError ? (
            <Button
              className="text-not-button-go-home"
              onClick={() => {
                navigate(PAGE.LOGIN);
              }}
            >
              <Trans i18nKey={"go_to_login"}></Trans>
            </Button>
          ) : (
            <Button
              className="text-not-button-go-home"
              onClick={handleGotoHome}
            >
              <Trans i18nKey={"go_to_home"}></Trans>
            </Button>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default NotFound;
